import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '../services/adminApi';

const ProtectedRoute = ({ children }) => {
  const [isAuth, setIsAuth] = React.useState(null);

  useEffect(() => {
    setIsAuth(isAuthenticated());
  }, []);

  if (isAuth === null) {
    return <div>Loading...</div>;
  }

  return isAuth ? children : <Navigate to="/admin/login" replace />;
};

export default ProtectedRoute;
